// Locale URL routing helpers
// URL slugs: /en/, /id/, /cn/, /th/, /ar/
// Internal context codes: EN, ID, CN, TH, AR

export const SUPPORTED_LOCALES = ["en", "id", "cn", "th", "ar"];

export const URL_TO_CODE = {
  en: "EN", id: "ID", cn: "CN", th: "TH", ar: "AR",
};

export const CODE_TO_URL = {
  EN: "en", ID: "id", CN: "cn", TH: "th", AR: "ar",
};

// hreflang ISO codes per locale
export const CODE_TO_ISO = {
  EN: "en", ID: "id", CN: "zh", TH: "th", AR: "ar",
};

export const DEFAULT_LOCALE_URL = "en";

/**
 * Strip locale prefix from pathname.
 * "/id/collection?x=1" → { locale: "id", rest: "/collection" }
 * "/collection"        → { locale: null, rest: "/collection" }
 */
export const stripLocale = (pathname = "/") => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length > 0 && SUPPORTED_LOCALES.includes(segments[0].toLowerCase())) {
    const locale = segments[0].toLowerCase();
    const rest = "/" + segments.slice(1).join("/");
    return { locale, rest: rest === "/" ? "/" : rest };
  }
  return { locale: null, rest: pathname || "/" };
};

/**
 * Build a locale-prefixed URL from a clean path.
 * prefixLocale("id", "/collection") → "/id/collection"
 * prefixLocale("en", "/")           → "/en"
 */
export const prefixLocale = (localeUrl, path = "/") => {
  const clean = path.startsWith("/") ? path : `/${path}`;
  if (clean === "/") return `/${localeUrl}`;
  return `/${localeUrl}${clean}`;
};

/**
 * Replace (or insert) the locale prefix in a pathname.
 * Used by the language switcher to navigate to the same page in a new language.
 */
export const swapLocale = (pathname, newLocaleUrl) => {
  const { rest } = stripLocale(pathname);
  return prefixLocale(newLocaleUrl, rest);
};
